export enum AdvancedSearchFilterSourceEnum {
	Recipe = 'Recipe',
	Menu = 'Menu',
	MenuPlan = 'MenuPlan',
	Ingredient = 'Ingredient',
	BaseIngredient = 'BaseIngredient',
	Accessory = 'Accessory',
}

export enum TriggeredFromEnum {
	Accessory = 'Accessory',
	Tags = 'Tags',
	Ingredient = 'Ingredient',
	Recipe = 'Recipe',
}

export function mapLocationToAdvancedSearchEnum(
	triggeredFrom: TriggeredFromEnum
): AdvancedSearchFilterSourceEnum | false {
	const path = window.location.pathname.toLowerCase();

	if (path.includes('recipe/search')) {
		if (triggeredFrom === TriggeredFromEnum.Recipe) return false;
		return AdvancedSearchFilterSourceEnum.Recipe;
	}

	return false;
}
